<template>
  <div class="bigTurntable" :class="{'isiOSX':isiOSX}">
    <van-nav-bar
      right-text="我的奖品"
      left-arrow
      @click-left="goBack"
      @click-right="myGift(0)"
      id="title"
      @scroll="handleScroll"
    />
    <div class="bigTurntable-content">
      <van-row>
        <van-col span="24" class="banner" :style="bannerPad">
          <!-- <button @click = "showStatus" style="position: fixed;top: 160px;left: 20px;">点我</button> -->
          <div class="giftBox">
            <div class="conBox">
              <transition name="slide-fade">
                <p class="gift" v-if="show">
                  <span class="tip">
                    <img :src="recordLast.prize_picture" @error="nofind()" />
                    恭喜{{ this.nicknameHandle(recordLast.member_nickname) }}抽到
                    <span>{{recordLast.prize_name ? recordLast.prize_name.substring(0,6)+'...' : '20积分...'}}</span>
                  </span>
                </p>
              </transition>
            </div>
          </div>
          <!--<p class="gift">
						<span class="tip"><img src="../../assets/game/crossYearBanner.png" @error="nofind()"/>恭喜梦**月抽到<span>2积分</span></span>
          </p>-->

          <!-- 新的 -->
          <div class="gifts" :style="giftsH">
            <div class="con">
              <p class="title">
                <img src="../../assets/game/lj_l.png" />
                {{credits_cost_once}}积分抽1次 {{credits_cost_quintic}}积分抽5次
                <img src="../../assets/game/lj_r.png" />
              </p>
              <van-row type="flex" justify="space-around">
                <van-col span="6" class="item">
                  <div :class="{'active':gift_index==1}">
                    <img src="../../assets/common/preload.png" />
                  </div>
                  <img
                    class="gift_img"
                    :src="prizeList.length ? prizeList[0].picture : ''"
                    @error="nofind()"
                  />
                </van-col>
                <van-col span="6" class="item">
                  <div :class="{'active':gift_index==2}">
                    <img src="../../assets/common/preload.png" />
                  </div>
                  <img
                    class="gift_img"
                    :src="prizeList.length ? prizeList[1].picture : ''"
                    @error="nofind()"
                  />
                </van-col>
                <van-col span="6" class="item">
                  <div :class="{'active':gift_index==3}">
                    <img src="../../assets/common/preload.png" />
                  </div>
                  <img
                    class="gift_img"
                    :src="prizeList.length ? prizeList[2].picture : ''"
                    @error="nofind()"
                  />
                </van-col>
                <van-col span="6" class="item">
                  <div :class="{'active':gift_index==4}">
                    <img src="../../assets/common/preload.png" />
                  </div>
                  <img
                    class="gift_img"
                    :src="prizeList.length ? prizeList[3].picture : ''"
                    @error="nofind()"
                  />
                </van-col>
              </van-row>

              <van-row type="flex" justify="space-around">
                <van-col span="6" class="item">
                  <div :class="{'active':gift_index==12}">
                    <img src="../../assets/common/preload.png" />
                  </div>
                  <img
                    class="gift_img"
                    :src="prizeList.length ? prizeList[11].picture : ''"
                    @error="nofind()"
                  />
                </van-col>
                <van-col span="6" class="item" offset="12">
                  <div :class="{'active':gift_index==5}">
                    <img src="../../assets/common/preload.png" />
                  </div>
                  <img
                    class="gift_img"
                    :src="prizeList.length ? prizeList[4].picture : ''"
                    @error="nofind()"
                  />
                </van-col>
              </van-row>

              <van-row type="flex" justify="space-around">
                <van-col span="6" class="item">
                  <div :class="{'active':gift_index==11}">
                    <img src="../../assets/common/preload.png" />
                  </div>
                  <img
                    class="gift_img"
                    :src="prizeList.length ? prizeList[10].picture : ''"
                    @error="nofind()"
                  />
                </van-col>
                <van-col span="6" class="item" offset="12">
                  <div :class="{'active':gift_index==6}">
                    <img src="../../assets/common/preload.png" />
                  </div>
                  <img
                    class="gift_img"
                    :src="prizeList.length ? prizeList[5].picture : ''"
                    @error="nofind()"
                  />
                </van-col>
              </van-row>

              <van-row type="flex" justify="space-around">
                <van-col span="6" class="item">
                  <div :class="{'active':gift_index==10}">
                    <img src="../../assets/common/preload.png" />
                  </div>
                  <img
                    class="gift_img"
                    :src="prizeList.length ? prizeList[9].picture : ''"
                    @error="nofind()"
                  />
                </van-col>
                <van-col span="6" class="item">
                  <div :class="{'active':gift_index==9}">
                    <img src="../../assets/common/preload.png" />
                  </div>
                  <img
                    class="gift_img"
                    :src="prizeList.length ? prizeList[8].picture : ''"
                    @error="nofind()"
                  />
                </van-col>
                <van-col span="6" class="item">
                  <div :class="{'active':gift_index==8}">
                    <img src="../../assets/common/preload.png" />
                  </div>
                  <img
                    class="gift_img"
                    :src="prizeList.length ? prizeList[7].picture : ''"
                    @error="nofind()"
                  />
                </van-col>
                <van-col span="6" class="item">
                  <div :class="{'active':gift_index==7}">
                    <img src="../../assets/common/preload.png" />
                  </div>
                  <img
                    class="gift_img"
                    :src="prizeList.length ? prizeList[6].picture : ''"
                    @error="nofind()"
                  />
                </van-col>
              </van-row>
              <!--<div @touchstart="gtouchstart(v)" @touchmove="gtouchmove()" @touchend="gtouchend(v)"></div>-->
              <div class="start">
                <div id="canvas1" :style="canvas1Sty"></div>
              </div>
              <div
                class="fake-start"
                @touchstart="gtouchstart(this)"
                @touchmove="gtouchmove()"
                @touchend="gtouchend(this)"
              ></div>
            </div>
          </div>

          <!-- 方案B：去掉幸运值 -->
          <!-- <div class="star_b" :style="star_b_H">
							<img :style="tails" src="../../assets/game/tails.png"/>
							<div>
									<img :style="luckyImg" src="../../assets/game/star_b.png"/>
		          </div>
						<div class="con">
							<span class="xyz_b" :style="luckyML">幸运值<span class="num_b">{{luckyValue}}</span></span>
						</div>
					</div>
          -->
        </van-col>
      </van-row>

      <div class="win" :style="winH">
        <div class="box">
          <div class="prize">
            <img class="left" src="../../assets/game/win_tit.png" />
            <img class="left" src="../../assets/game/win_tit.png" />
            <div class="adv">
              <ul>
                <li :style="liW" v-for="(item, index) in images" :key="index">
                  <img :src="item" @error="nofind()" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <van-row class="rule">
        <van-col span="24" class="title">{{activity_rules.title}}</van-col>
        <van-col
          span="24"
          class="con"
          v-for="(item,i) in activity_rules_values"
          :key="i"
        >{{ `${item}` }}</van-col>
        <!-- <van-col span="24" class="con">2、每次抽奖后积分值减小相应值;</van-col>
				<van-col span="24" class="con">3、每抽奖一次，均会增加一定数量的幸运值，幸运值越高，获得特等奖物品的机会就越大;</van-col>
				<van-col span="24" class="con">4、获得特等奖时，幸运值会重置为0，重新累计;</van-col>
				<van-col span="24" class="con">5、抽中的非实物奖品将在30分钟内发放;</van-col>
				<van-col span="24" class="con">6、实物奖品中奖用户在平台审核通过后，请在我的奖品列表填写收货地址;</van-col>
				<van-col span="24" class="con">7、无有效收件信息情况下，5次拨打联系手机拒接或无法接通者视为放弃奖品;</van-col>
				<van-col span="24" class="con">8、活动奖品将不定期更新，请留意奖品区域变化;</van-col>
        <van-col span="24" class="con">9、通过非法手段获取积分或奖品者经查证后被取消获奖资格;</van-col>-->
        <!-- <van-col span="24" class="con">10、本活动最终解释权归销巴生活官方所有，我们保留随时进行适当调整的权利。联系电话: 400-0571671 (工作日: 10:00-17:00)</van-col> -->
      </van-row>
    </div>

    <van-popup v-model="popupShow" class="win_pop" :style="popupW">
      <div class="popupBox" :style="popupW_box">
        <div id="canvas3" :style="popupW"></div>
        <!--:style="{'padding': '0 '+padd1+'%'}"  transform: "scale(" + ratioW + "," +ratioH +")",
        transformOrigin: 'left top',-->
        <div class="oneProduct" :style="scale" v-if="!nineInterger && !isThanks && lotteryResult2.prize_name" >
          <img class="bg" :style="rotaion" src="../../assets/game/winBg_pop.png" />
          <img class="product" :style="productH1" :src="lotteryResult2.picture" />
          <p>{{ lotteryResult2.prize_name.substring(0,6) + '...'}}</p>
        </div>
        <div
          class="oneProduct fiveProduct"
          :style="scale"
          v-if="nineInterger && !isThanks && lotteryResult9.length"
        >
          <img class="bg" :style="rotaion" src="../../assets/game/winBg_pop.png" />
          <div class="product">
            <img :style="productH5" :src="lotteryResult9[0].picture" />
            <p>{{lotteryResult9[0].prize_name}}</p>
          </div>
          <div class="product product_lt">
            <img :style="productH5" :src="lotteryResult9[1].picture" />
            <p>{{lotteryResult9[1].prize_name}}</p>
          </div>
          <div class="product product_rt">
            <img :style="productH5" :src="lotteryResult9[2].picture" />
            <p>{{lotteryResult9[2].prize_name}}</p>
          </div>
          <div class="product product_lb">
            <img :style="productH5" :src="lotteryResult9[3].picture" />
            <p>{{lotteryResult9[3].prize_name}}</p>
          </div>
          <div class="product product_rb">
            <img :style="productH5" :src="lotteryResult9[4].picture" />
            <p>{{lotteryResult9[4].prize_name}}</p>
          </div>
        </div>
        <p class="btn" v-if="btnShow" :style="btnStyle">
          <img
            class="left"
            v-if="!nineInterger"
            src="../../assets/game/two@2x (2).png"
          />
          <img
            class="left"
            v-if="nineInterger"
            src="../../assets/game/nine@2x.png"
          />
          <span class="text" v-if="!nineInterger" 
            @touchstart="lotteryStatus = lotteryStatus === 2 ? 0 : lotteryStatus"
            @touchmove="isTouchMove=true"
            @touchend="shortPressAgain()">{{ credits_cost_once }}积分再抽1次</span>
          <span class="text" v-if="nineInterger" 
            @touchstart="lotteryStatus = lotteryStatus === 2 ? 0 : lotteryStatus"
            @touchmove="isTouchMove=true"
            @touchend="longPressAgain()">{{ credits_cost_quintic }}积分再抽5次</span>
          <img class="right" @click="again('set')" :src="flag ? address  : determine" />
        </p>
      </div>
      <div class="buttonClose"><img @click="again('close')" src="../../assets/game/close.png" /></div>
    </van-popup>
    <popup 
    :titleText="activityOverMessage"
    :isShow="activityOverShow"
    @popupConfirm="goBack"
    >
    </popup>
  </div>
</template>
<script>
import SVGA from "svgaplayerweb";
import Popup from "./components/popup.vue"
import defaultImg from "@/assets/common/avatar.png";
import { resolve } from "url";
import { log } from "util";
// import { tr } from 'date-fns/locale';
export default {
  components: {
    Popup
  },
  data() {
    return {
     address :require("../../assets/game/address.png"),
     determine :require("../../assets/game/determine.png"),
      bannerPad: {
        paddingTop: document.body.clientWidth * 0.54 + "px",
      },
      giftsH: {
        height: document.body.clientWidth - 66 + 18 + "px",
      },
      btnW: {
        width: (document.body.clientWidth - 57) / 2 + "px",
      },
      winH: {
        height: (document.body.clientWidth - 38) * 0.353 + "px",
      },
      liW: {
        width: (document.body.clientWidth - 56) * 0.777 * 0.335 + "px",
      },
    //   ulW: {
    //     width: "",
    //   },
      star_b_H: {
        height: (document.body.clientWidth - 38) * 0.131 + "px",
        lineHeight: (document.body.clientWidth - 38) * 0.131 + "px",
      },
      tails: {
        width: "0",
        opacity: 0,
        marginLeft: "19px",
        height: (document.body.clientWidth - 38) * 0.298 * 0.7 + "px",
        marginTop: -(document.body.clientWidth - 38) * 0.298 * 0.15 + "px",
      },
      luckyImg: {
        position: "absolute",
        left: 0,
        height: (document.body.clientWidth - 38) * 0.298 + "px",
        top: -(((document.body.clientWidth - 38) * (0.298 - 0.131)) / 2) + "px",
      },
      luckyML: { marginLeft: "19%" },
      luckyValue: 0,
      images: [
        // 'https://img.yzcdn.cn/vant/apple-1.jpg',
        // 'https://img.yzcdn.cn/vant/apple-2.jpg',
        // 'https://img.yzcdn.cn/vant/apple-1.jpg',
        // 'https://img.yzcdn.cn/vant/apple-2.jpg',
        // 'https://img.yzcdn.cn/vant/apple-1.jpg',
        // 'https://img.yzcdn.cn/vant/apple-2.jpg'
      ],
      gift_index: 4,
      gift_arr: [4, 6, 8, 12, 11, 10, 9, 7, 5, 1, 2, 3],
      arr_gift_index: [1, 2, 3, 4, 6, 8, 12, 11, 10, 9, 7, 5],
      timeOutEvent: 0,
      show: false, //从false变为true需要加0.17s的延迟
      btn1Base64: "",
      btn2Base64: "",
      btn3Base64: "",
      oneProductBase64: "",
      fiveProductBase64: "",
      thanksBase64: "",
      popupShow: false,
      popupW: { height: document.body.clientHeight + "px" },
      popupW_box: {
        height: document.body.clientHeight + "px",
        transform: "scale(1)",
        transition: "all .117s linear",
        opacity: 1,
      },
      btnShow: false,
      btnStyle: {},
      scale: { transform: "scale(0)" },
      productH1: { height: document.body.clientWidth * 0.25 + "px" },
      productH5: { height: document.body.clientWidth * 0.16 + "px" },
      nineInterger: false,
      isThanks: true, //若为true则显示谢谢参与动画
      rotaion: { transform: "rotate(0deg)", transition: "all 9.5s linear" },
      timer: 0,
      timer5: 0,
      isiOSX: false,
      canvas1Sty: {
        transform: "scale(1)",
        transition: "all .1s linear",
        position: "absolute",
        top: "0",
        left: "0",
      },
      prizeList: [],
      activity_rules: {},
      activity_rules_values: [],
      isTouchMove: false,
      lotteryResult2: {},
      lotteryResult9: [],
      recordLast: {},
      timer7: 0,
      timer8: 0,
      credits_cost_once: "",
      credits_cost_quintic: "",
      // -1表示未知状态 0表示积分不足  1表示积分足够
      coinOnceEnough: -1,
      coinQuinticEnough: -1,
      activityOverShow: false,
      activityOverMessage: "",
      persistGiftIndex: 1,
      giftStoper: {},
      // 0 空闲  1 正在抽奖  2 抽奖已完成，需要在touchstart中置为0
      lotteryStatus: 0,
      flag:false,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(this.$route.query.token);
    this.validateLottery()
    // this.luckyStar(55); //2  66  99
    // this.ulW.width =
    //   ((document.body.clientWidth - 56) * 0.777 * 0.335 + 12) *
    //     this.images.length - 12 +"px";
    this.getPrizeList();
    this.setContent();
    this.updateCoinIsEnough();
  },
  methods: {
    validateLottery(){
      this.$api.post('/activity/member/turntable/setting/prize').then(data => {
        this.credits_cost_once = data.credits_cost_once;
        this.credits_cost_quintic = data.credits_cost_quintic;
        if (data.turntable_display == 0 ){
          this.activityOverShow = true
          this.activityOverMessage = '活动维护中，请稍后再试'
        }

      });

    },
    handleScroll() {
      //页面滚动
      var scrollTop = document.querySelector(".bigTurntable-content").scrollTop;
      // var offsetTop = document.querySelector('#changeSearch').offsetTop;
      var offsetTop = 165;
      var point = Number(scrollTop / 165).toFixed(1);
      if (scrollTop > offsetTop) {
        document.querySelector("#title").style.backgroundColor =
          "rgba(81, 44, 181, 1)";
      } else {
        if (point < 0.3) {
          document.querySelector("#title").style.backgroundColor =
            "rgba(81, 44, 181, 0)";
        } else {
          document.querySelector("#title").style.backgroundColor =
            "rgba(81, 44, 181, " + point + ")";
        }
      }
    },
    //幸运星
    // luckyStar(luckyVal) {
    //   this.luckyValue = luckyVal;
    //   if (luckyVal >= 1 && luckyVal <= 33) {
    //     this.toLong(0.203, 0.363, 0.01);
    //     this.luckyML = { marginLeft: "41.3%" };
    //   } else if (luckyVal >= 34 && luckyVal <= 67) {
    //     this.toLong(0.341, 0.545, 0.01);
    //     this.luckyML = { marginLeft: "56.3%" };
    //   } else if (luckyVal >= 68 && luckyVal <= 100) {
    //     this.toLong(0.501, 0.726, 0.01);
    //     this.luckyML = { marginLeft: "74.3%" };
    //   }
    // },
    toLong(left, width, opacity) {
      //this.luckyImg.left, this.tails.width,  this.tails.opacity
      var i = 0;
      var timer1 = setInterval(() => {
        i++;
        if (i == 101) {
          clearInterval(timer1);
        } else {
          this.tails.width = width * i + "%";
          this.tails.opacity = opacity * i;
          this.luckyImg.left = left * i + "%";
        }
      }, 8.3); //循环100次即为0.83s
    },
    //有新的中奖消息时的动效
    // showStatus() {
    // 	this.show = false;
    // 	setTimeout(()=> {
    //     this.$api.post('activity/member/turntable/record/last',{"item":1}).then(data =>{
    //       // console.log(data);
    //       this.recordLast = data.list

    //     })
    // 		this.show = true;
    // 	}, 510);//从false变为true需要加0.17s的延迟+变化过程需要0.34s
    // },
    myGift(active) {
      this.$router.push({
        path: "/game/myProfit",
        		query: {
                token: localStorage.getItem('_token'),
                active:active
        		}
      })
    },
    slowOnRoundStart(){
      this.gift_index = 5
      this.slow_timer = setInterval(() => {
        this.gift_index ++;
        if (this.gift_index == 13) {
          this.gift_index = 1;
        }
      }, 750);
    },
    slowOnRoundStop(){
      clearInterval(this.slow_timer)
    },
    //开始按
    gtouchstart(item) {
      document.oncontextmenu = function (e) {
        e.preventDefault();
      };
      if (this.lotteryStatus === 2) {
        this.lotteryStatus = 0
      }
      this.timeOutEvent = setTimeout(() => {
        // 定时器里的代码开始执行，说明已经过了一秒
        //开始按钮在长按一秒后开始100%变成93%以此代表用户进行了长按操作
        //		    	this.canvas1Sty = {transform: 'scale(.93)', transition: 'all 1s linear', position: 'absolute', top: '3.5%', left: '3.5%'}
        this.canvas1Sty = {
          transform: "scale(.93)",
          transition: "all 1s linear",
        };
        this.longPress(item);
      }, 1000); //这里设置定时器，定义长按1秒触发长按事件，时间可以自己改
      return false;
    },
    //手释放，如果在1内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
    gtouchend(item) {
      clearTimeout(this.timeOutEvent); //清除定时器,取消长按执行
      if (this.isTouchMove) {
        this.isTouchMove = false;
        return;
      }

      if (this.lotteryStatus === 1) {
        return
      }
      if (this.lotteryStatus === 2) {
        this.lotteryStatus = 0
        return
      }

      if (this.coinOnceEnough === -1) {
        this.$toast("网络错误");
        this.isTouchMove = true
        this.updateCoinIsEnough();
        return;
      }
      if (this.coinOnceEnough === 0) {
        this.$toast("积分不足");
        this.isTouchMove = true
        this.updateCoinIsEnough();
        return;
      }
      this.nineInterger = false;
      this.lotteryStatus = 1
      this.slowOnRoundStop()
      this.SVGA(this.btn2Base64, "#canvas1", "1000");
      this.giftStart();
      //这里写要执行的内容（尤如onclick事件）
      this.$api
        .post(
          "activity/member/turntable/prize/draw",
          { type: 1 },
          { timeout: 6020 }
        )
        .then((data) => {
          this.updateCoinIsEnough();
          this.lotteryResult2 = data;
          this.flag = this.lotteryResult2.real !== 0;
          setTimeout(() => {
            this.giftStop(this.lotteryResult2.prize_id, "one");
            // 控制 1805 ms（50*12*3+5）3圈 后才能出结果
          }, 1805)
        })
        .catch((err) => {
          // 252200 用户积分不足
          if (err.code === 252200) {
            this.coinOnceEnough = 0
            this.$toast("积分不足");
          }else if(err.code === 252208){
            this.$toast("账号违规，暂不可参与该活动，具体请联系客服");
          }
          this.giftStop(-1);
        });
      // this.nineInterger = false;
    },
    //如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    gtouchmove() {
      clearTimeout(this.timeOutEvent); //清除定时器
      this.isTouchMove = true;
    },
    shortPressAgain() {
      this.SVGA(this.btn1Base64, "#canvas1", "10000000");
      if (this.isTouchMove) {
        this.isTouchMove = false;
        return;
      }
      this.delCanvas3();
      setTimeout(() => {
        this.gtouchend();
      }, 300);
    },
    longPressAgain() {
      this.SVGA(this.btn1Base64, "#canvas1", "10000000");
      if (this.isTouchMove) {
        this.isTouchMove = false;
        return;
      }
      this.delCanvas3();
      setTimeout(() => {
        this.longPress();
      }, 300);
    },
    //长按时调用
    longPress(item) {
      if (this.lotteryStatus !== 0) {
        return
      }
      if (this.coinQuinticEnough === -1) {
        this.$toast("网络错误");
        this.isTouchMove = true
        this.updateCoinIsEnough();
        return;
      }
      if (this.coinQuinticEnough === 0) {
        this.$toast("积分不足");
        this.isTouchMove = true
        this.updateCoinIsEnough();
        return;
      }
      // 设置长按抽奖结束后左边button为 9积分样式
      this.nineInterger = true;
      this.lotteryStatus = 1
      this.slowOnRoundStop()
      this.giftStart();
      // 弹出 3 2 1 倒计时按钮动画
      this.SVGA(this.btn3Base64, "#canvas1", "1");
      setTimeout(() => {
        this.SVGA(this.btn2Base64, "#canvas1", "1000");
      }, 3000);
      
      this.$api
        .post(
          "activity/member/turntable/prize/draw",
          { type: 2 },
          { timeout: 6000 }
        )
        .then((data) => {
          this.updateCoinIsEnough();
          this.lotteryResult9 = data;
          this.flag = this.lotteryResult9.some(item=>item.real !== 0)
          let _min = 100
          data.forEach(item => {
            if (item.prize_id < _min) {
              _min = item.prize_id
            }
          })
          setTimeout(() => {
            this.giftStop(_min, "five");
            // 控制3s 后才会出结果，
          }, 3000)
        })
        .catch((err) => {
          // 252200 用户积分不足
          if (err.code === 252200) {
            this.coinQuinticEnough = 0
            this.$toast("积分不足");
          }else if(err.code === 252208){
            this.$toast("账号违规，暂不可参与该活动，具体请联系客服");
          }
          this.giftStop(-1);
        });
    },
    updateCoinIsEnough() {
      this.$api
        .post("activity/member/turntable/user/credits")
        .then((res) => {
          if (res.nowCredits >= this.credits_cost_quintic) {
            this.coinQuinticEnough = 1;
            this.coinOnceEnough = 1;
          }
          if (res.nowCredits >= this.credits_cost_once && res.nowCredits < this.credits_cost_quintic) {
            this.coinOnceEnough = 1;
            this.coinQuinticEnough = 0;
          }
          if (res.nowCredits < this.credits_cost_once) {
            this.coinQuinticEnough = 0;
            this.coinOnceEnough = 0;
          }
        })
        .catch(() => {
          this.coinQuinticEnough = -1;
          this.coinOnceEnough = -1;
        });
    },
    goBack() {
      this.params("", "", "goBack");
    },
    nofind() {
      var img = event.srcElement;
      img.src = defaultImg;
      img.onerror = null; //防止闪图
    },
    giftStart() {
      this.gift_index = this.persistGiftIndex
      this.persistGiftIndex ++
      this.persistGiftIndex = this.persistGiftIndex == 13 ? 1 : this.persistGiftIndex

      this.timer = setInterval(() => {
        // 一旦开始，每次循环判断是否停止
        if (this.giftStoper.prize_id === -1 || this.giftStoper.prize_id === this.gift_index) {
          clearInterval(this.timer)
          this.giftStoper.callback(this.giftStoper.prize_id, this.giftStoper.type)
          return
        }
        this.gift_index ++;
        if (this.gift_index == 13) {
          this.gift_index = 1;
        }
      }, 25);
    },
    // param: type 
    // one为一次抽奖  five为5连抽
    giftStop(prize_id, type) {
      const cb = (prize_id, type) => {
        if (prize_id < 1 || prize_id > 12) {
          this.giftStopPopup(prize_id, type)
          return
        }
        let _tmp_index = prize_id
        let _counter20 = 0
        const timer20 = setInterval(()=>{
          // 这里的4 控制闪烁次数
          if (_counter20 == 4) {
            clearInterval(timer20)
            this.giftStopPopup(prize_id, type)
          }
          if (_counter20 % 2 == 0) {
            this.gift_index = -1
          }else {
            this.gift_index = _tmp_index
          }
          _counter20 ++
          // 200 ms闪烁一次
        },200)
      }
      this.giftStoper = {
        stop: 1,
        prize_id: prize_id,
        type: type,
        callback: cb,
      }
    },
    giftStopPopup(prize_id, type){
      if (prize_id === -1) {
          this.gift_index = -1;
          this.SVGA(this.btn1Base64, "#canvas1", "10000000");
          this.lotteryStatus = 2
          return
      }
      this.popupShow = true;

      // let _is_thanks
      // if (type === "one") {
      //   _is_thanks = this.lotteryResult2.prize_level === "谢谢参与"
      // }else {
      //   _is_thanks = this.lotteryResult9.every(item => item.prize_level === "谢谢参与")
      // }
      if (type === "one" && this.lotteryResult2.level === "谢谢参与") {
        // 这里使用nextTick是因为要等画布展开，而弹出窗口是基于画布的
        this.$nextTick(() => {
          this.isThanks = true;
          this.SVGA(this.thanksBase64, "#canvas3", "1", "stop");
          this.giftStoper = {}
          // 抽奖状态在抽完之后，总是会变成2，必须在touchstart中手动置为0
          this.lotteryStatus = 2
        });
      } else {
        this.$nextTick(() => {
          this.isThanks = false;
          if (type == "one") {
            this.SVGA(this.oneProductBase64, "#canvas3", "1", "stop");
          }
          if (type == "five") {
            this.SVGA(this.fiveProductBase64, "#canvas3", "1", "stop");
          }
          this.giftStoper = {}
          this.lotteryStatus = 2
        });
      }
    },
    SVGA(fileUrl, svgaElement, loops, stop) {
      var _this = this;
      let player = new SVGA.Player(svgaElement);
      let parser = new SVGA.Parser(svgaElement);
      parser.load(fileUrl, function (videoItem) {
        player.loops = loops; // 设置循环播放次数是 1
        player.setVideoItem(videoItem);
        player.stepToFrame(0, true); // 从指定帧开始播放动画
        if (stop) {
          player.clearsAfterStop = false;
          setTimeout(() => {
            //以苹果6为基准，117即为(苹果6屏幕高度 - 苹果6屏幕宽度 * 1.3)
            let btnHei = (document.body.clientHeight - document.body.clientWidth * 1.3) / 117 *20;
             _this.btnStyle = {
                transition: "all .38s linear",
                transform: "translateY(-"+btnHei+"px)",
                opacity: 1,
              };
            // if (_this.isiOSX) {
            //   _this.btnStyle = {
            //     transition: "all .38s linear",
            //     transform: "translateY(-50px)",
            //     opacity: 1,
            //   };
            // } else {
            //   _this.btnStyle = {
            //     transition: "all .38s linear",
            //     transform: "translateY(-20px)",
            //     opacity: 1,
            //   };
            // }

            if (!_this.isThanks) {
              //抽中奖品才需要弹框背景光效
              _this.rotate();
            }
            _this.scalc();
          }, 580);
        }
        player.onFrame((i) => {
          if (i >= 18 && stop) {
            //i=18时弹窗已展开，此时可以开始再抽一次的按钮动画
            _this.btnShow = true;
          }
        });
      });
    },
    SVGADEL(svgaElement) {
      clearInterval(this.timer5)
      this.rotaion.transform = "rotate(0deg)";
      this.scale.transform = "scale(0)";
      this.btnStyle = {
        transition: "all 0s linear",
        transform: "translateY(0px)",
        opacity: 0,
      };
      let player = new SVGA.Player(svgaElement);
      player.clear();
    },
    rotate() {
      this.rotaion.transform = "rotate(360deg)";
      var i = 1;
      this.timer5 = setInterval(() => {
        i++;
        var val = 360 * i;
        this.rotaion.transform = "rotate(" + val + "deg)";
      }, 9500);
    },
    scalc() {
      var i = 0;
      var timer3 = setInterval(() => {
        i++;
        if (i == 11) {
          clearInterval(timer3);
        } else {
          var val = 0.1 * i;
          this.scale = { transform: "scale(" + val + ")" };
        }
      }, 38);
    },
    delCanvas3() {
      this.popupW_box.transform = "translateY(940px)";
      this.popupW_box.transition = "all .3s linear";
      this.popupW_box.opacity = 0;
      setTimeout(() => {
        this.SVGADEL("#canvas3");
        this.popupShow = false;
        this.popupW_box.transform = "scale(1)";
        this.popupW_box.transition = "all .117s linear";
        this.popupW_box.opacity = 1;
      }, 300);
    },
    again(close) {
      this.canvas1Sty = { transform: "scale(1)" }; //恢复抽奖按钮大小
      if (this.isThanks) {
        //谢谢参与关闭动效
        this.delCanvas3();
        this.slowOnRoundStart()
      } else {
        //奖品弹框飞入我的奖品动效一共分四步完成
        var box_x = (document.body.clientWidth * 0.5 - 50) / 4;
        var box_y = -document.body.clientHeight * 0.5 + 30;
        var x = box_x * 1;
        var y = (box_y / 6) * 4;
        var scale = 0.06;
        this.popupW_box.transform =
          "matrix(" + scale + ",0,0," + scale + "," + x + "," + y + ")"; //该循环的第一步
        var i = 1; //i=1 代表该循环从第二步开始（第一步在上面一行）
        var timer4 = setInterval(() => {
          i++;
          if (i == 5) {
            this.SVGADEL("#canvas3");
            this.popupShow = false;
            clearInterval(timer4);
            clearInterval(this.timer5); //奖品弹框背景光效
            this.slowOnRoundStart()
            setTimeout(() => {
              this.popupW_box.transform = "scale(1)";
            }, 1000);
          } else {
            x = box_x * i;
            if (i == 2) {
              scale = 0.06;
              y = box_y;
            } else if (i == 3) {
              scale = 0.05;
              y = box_y - 15;
            } else {
              scale = 0.04;
              y = box_y;
            }
            this.popupW_box.transform =
              "matrix(" + scale + ",0,0," + scale + "," + x + "," + y + ")";
          }
        }, 117);
          if(this.flag && close==='set')this.myGift(2)
      }
      this.SVGA(this.btn1Base64, "#canvas1", "10000000");
    },
    getPrizeList() {
      this.$api.post("/activity/member/turntable/prize/list").then((data) => {
        this.prizeList = data.list;
      });
    },
    setContent() {
      this.$api
        .post("activity/member/turntable/setting/content")
        .then((data) => {
          var _image = data.picture.forEach((item) => {
            let _image = item.value;
            return this.images.push(_image);
          });
          this.activity_rules = data.activity_rules;
          this.activity_rules_values = data.activity_rules.value.trim().split("\n");
        });
    },
    showUserPrizeInfo() {

      // 这个timer10 记得去destroy中清掉
        this.$api
          .post("activity/member/turntable/record/last", { item: 10})
          .then((data) => {
            // if (data.list.length === 0) return;
            this.timer10 = setInterval(() => {
            var num = data.list.length;
            var index = parseInt(Math.random()*num);
            this.recordLast = data.list[index];
            this.show = !!this.recordLast;
                setTimeout(() => {
                  this.show = false;
                }, 2000);
          }, 4000);
            // if (data.list.length === 0) return;
            // this.recordLast = data.list[0];
            // this.show = true;
            // setTimeout(() => {
            //   this.show = false;
            // }, 2000);
          });
      ;
    },
  },
  mounted() {
    // this.giftStart();
    document
      .querySelector(".bigTurntable-content")
      .addEventListener("scroll", this.handleScroll);
    document.querySelector("#title").style.backgroundColor =
      "rgba(81, 44, 181, 0)";
    this.btn1Base64 = `${location.protocol}//others.qiniudns.shall-buy.com/btn1.svga`;
    this.btn2Base64 = `${location.protocol}//others.qiniudns.shall-buy.com/btn2.svga`;
    this.btn3Base64 = `${location.protocol}//others.qiniudns.shall-buy.com/btn3.svga`;
    this.oneProductBase64 =
      `${location.protocol}//others.qiniudns.shall-buy.com/oneProduct.svga`;
    this.fiveProductBase64 =
      `${location.protocol}//others.qiniudns.shall-buy.com/fiveProduct.svga`;
    this.thanksBase64 = `${location.protocol}//others.qiniudns.shall-buy.com/thanks.svga`;
    this.SVGA(this.btn1Base64, "#canvas1", "10000000");
    this.showUserPrizeInfo();
    this.slowOnRoundStart()
    // setInterval(() =>{
    //   this.$api.post("activity/member/turntable/record/last",{"item":3}).then((data) => {
    //     this.recordLast = data.list
    //   })
    //   this.show = false
    // },2000)

    //		this.SVGA(this.thanksBase64, '#canvas3', '1', 'stop');//谢谢参与
    //this.SVGA(this.oneProductBase64, '#canvas3', '1', 'stop');//单次抽中奖信息
    //this.SVGA(this.fiveProductBase64, '#canvas3', '1', 'stop');//五连抽中奖信息
  },
  destroyed() {
    const contentDom = document.querySelector(".bigTurntable-content");
    if (contentDom) {
      contentDom.removeEventListener("scroll", this.handleScroll);
    }
    clearInterval(this.timer10);
  },
};
</script>
<style lang='less' scoped>
.bigTurntable {
  background: #512db6;
  height: 100%;
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早起浏览器*/
  -moz-user-select: none; /*火狐浏览器*/
  -ms-user-select: none; /*IE浏览器*/
  user-select: none; /*用户是否能够选中文本*/
  .van-nav-bar {
    background: rgba(255, 255, 255, 0);
    padding-top: 24px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 6 !important;
    width: 100%;
    .van-nav-bar__title {
      font-size: 18px;
      color: #333;
    }
    .van-icon-arrow-left:before {
      display: none;
    }
    .van-nav-bar__left {
      left: 0;
      .van-icon {
        width: 44px;
        height: 28px;
        display: inline-block;
        background: url(../../assets/game/reback.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }
    .van-nav-bar__text {
      width: 81px;
      height: 28px;
      line-height: 28px;
      color: #fff;
      font-size: 14px;
      text-align: center;
      background: rgba(29, 30, 31, 0.2);
      border-top-left-radius: 14px;
      border-bottom-left-radius: 14px;
      padding: 0;
    }
  }
  .van-hairline--bottom:after {
    border: none;
  }
  .bigTurntable-content {
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    // margin-bottom: 19px;
    .banner {
      /*height: 660px;*/
      /*margin-top: -70px;*/
      background: url(../../assets/game/banner.png) no-repeat top center;
      background-size: 100% auto;
      /* 可以设置不同的进入和离开动画 */
      /* 设置持续时间和动画函数 */
      .slide-fade-enter-active {
        transition: all 0.34s linear;
      }
      .slide-fade-leave-active {
        transition: all 0.34s linear; /*代表匀速linear或cubic-bezier(0, 0, 1, 1)*/
      }
      .slide-fade-enter, .slide-fade-leave-to
			/* .slide-fade-leave-active 用于 2.1.8 以下版本 */ {
        transform: translateX(-120px);
        opacity: 0;
      }
      .giftBox {
        height: 41px;
        padding-left: 20px;
        .conBox {
          overflow: hidden;
          .gift {
            margin-bottom: 11px;
            .tip {
              display: inline-block;
              height: 30px;
              line-height: 30px;
              text-align: left;
              padding-left: 32px;
              font-size: 13px;
              color: #ffffff;
              padding-right: 8px;
              background: rgba(29, 30, 31, 0.25);
              border-radius: 16px;
              position: relative;
              img {
                width: 16px;
                height: 16px;
                border-radius: 8px;
                border: solid 1px #ffffff;
                position: absolute;
                top: 6px;
                left: 8px;
              }
              span {
                color: #fedb67;
              }
            }
          }
        }
      }
    }
    .gifts {
      padding: 0 19px;
      .con {
        height: 100%;
        padding: 14px;
        position: relative;
        background: url(../../assets/game/bg1.png) no-repeat top center;
        background-size: 100% 100%;
        .title {
          color: #ffe69f;
          font-size: 11px;
          text-align: center;
          height: 16px;
          line-height: 16px;
          margin-bottom: 3px;
          img {
            width: 31px;
            margin: 0 9px;
            vertical-align: middle;
          }
        }
        .item {
          padding: 5px;
          position: relative;
          div {
            text-align: center;
            padding: 10px;
            border-radius: 14px;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            background: -webkit-linear-gradient(
              rgba(255, 242, 198, 0.6),
              rgba(237, 199, 104, 0.6)
            );
            background: -o-linear-gradient(
              rgba(255, 242, 198, 0.6),
              rgba(237, 199, 104, 0.6)
            );
            background: -moz-linear-gradient(
              rgba(255, 242, 198, 0.6),
              rgba(237, 199, 104, 0.6)
            );
            background: linear-gradient(
              rgba(255, 242, 198, 0.6),
              rgba(237, 199, 104, 0.6)
            );
            transition: all 0.55s linear;
            transform: translateX(0);
            opacity: 0.6;
            img {
              display: block;
              width: 100%;
              height: 100%;
              opacity: 0;
            }
          }
          .active {
            background: -webkit-linear-gradient(
              #fff2c6,
              #edc768
            ); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(
              #fff2c6,
              #edc768
            ); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(
              #fff2c6,
              #edc768
            ); /* Firefox 3.6 - 15 */
            background: linear-gradient(#fff2c6, #edc768);
            transition: all 0.6s linear;
            transform: translateX(0);
            opacity: 1;
          }
          .gift_img {
            display: block;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            padding: 15px;
            box-sizing: border-box;
            display: block;
          }
        }
        .start {
          width: 64.5%;
          height: 61%;
          position: absolute;
          top: 21.7%;
          left: 18.5%;
          overflow-x: hidden; // 解决抽奖可以向左滑动问题
          overflow-y: hidden;
          #canvas1 {
            width: 100%;
            height: 100%;
          }
        }
        .fake-start {
          // 解决奖品可以点击抽奖的bug
          width: 120px;
          height: 120px;
          border-radius: 50%;
          position: absolute;
          top: 52%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 100;
        }
      }
    }

    // .star_b{
    // 	padding: 0 19px;
    // 	margin-top: 44px;
    // 	margin-bottom: 8px;
    // 	position: relative;
    // 	.con {
    // 		width: 100%;
    // 		height: 100%;
    //   	background: url(../../assets/game/starBg.png) no-repeat center center;
    //   	background-size: 100% 100%;
    //   	.xyz_b {
    //   		color: #FFE065;
    //   		font-size: 12px;
    //   		margin-left: 19%;
    //   		.num_b {
    //   			font-size: 18px;
    //   			margin-left: 3px;
    //   		}
    //   	}
    // 	}
    // 	img {
    // 		position: absolute;
    // 		left: 0;
    // 	}
    // }

    .win {
      padding: 0 19px;
      margin-top: 44px;
      .box {
        height: calc(100% - 19px);
        padding: 10px 9px 9px;
        background: url(../../assets/game/win_bg.png) no-repeat center center;
        background-size: 100% 100%;
        .prize {
          height: 100%;
          padding-left: 22.3%;
          position: relative;
          .left {
            width: 22.3%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
          }
          .adv {
            width: 100%;
            height: 100%;
            overflow-y: scroll;
            ul {
              /*width: 2200px; //苹果手机晒图不一行显示*/
              display: inline-flex;
              height: 100%;
              box-sizing: content-box;
              li {
                width: 100px;
                height: calc(100% - 17px);
                float: left;
                padding: 8px 0 9px 0;
                margin-left: 12px;
                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 8px;
                }
              }
              li:first-child {
                margin: 0;
              }
            }
          }
        }
      }
    }
    .rule {
      padding: 15px 20px 16px;
      .title {
        color: #fed44a;
        font-size: 16px;
        font-weight: bold;
        text-align: left;
        height: 22px;
        line-height: 22px;
        margin-bottom: 8px;
      }
      .con {
        color: rgba(255, 255, 255, 0.8);
        font-size: 13px;
        line-height: 24px;
        text-align: left;
      }
    }
  }
  /*.van-overlay {    
  	z-index: 2010;
  	background-color: rgba(0, 0, 0, 0);
  }*/
  .win_pop {
    padding: 0;
    margin: 0;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    background: transparent;
    .popupBox {
      .oneProduct {
        padding: 0 25%;
        position: fixed;
        top: 35%;
        height: auto;
        .bg {
          width: 100%;
        }
        .product {
          width: 25%;
          position: absolute;
          top: 25%;
          left: 37.5%;
        }
        p {
          color: #d58848;
          text-align: center;
          font-size: 16px;
          margin-top: -20px;
        }
      }
      .fiveProduct {
        padding: 0 22%;
        .product {
          width: 16%;
          position: absolute;
          top: 32%;
          left: 42%;
          img {
            width: 100%;
          }
          p {
            color: #d58848;
            text-align: center;
            font-size: 13px;
            line-height: 18px;
            margin: 0;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
        .product_lt {
          top: 4%;
          left: 20%;
        }
        .product_rt {
          top: 4%;
          right: 20%;
          left: auto;
        }
        .product_lb {
          left: 20%;
          bottom: 4%;
          top: auto;
        }
        .product_rb {
          right: 20%;
          bottom: 4%;
          top: auto;
          left: auto;
        }
      }
      .btn {
        padding: 0 20%;
        position: fixed;
        top: 71%;
        opacity: 0;
        text-align: center;
        .left {
          width: 51.1%;
        }
        .right {
          width: 48.9%;
        }
        .text {
          position: absolute;
          top: 48%;
          left: 35%;
          transform: translate(-50%,-50%);
          font-size: 14px;
          font-weight: 600;
          color: #ffff;
        }
        // .text:last-child {
        //   left: 21%;
        // }
       
      }
    }
  }
}
 .buttonClose{
            position: fixed;
            top: 84%;
            width: 100%;
            text-align: center;
            img{
              width: 28px;
              height: 28px;
          }
        }
.isiOSX {
  padding-top: 20px;
  .van-nav-bar {
    padding-top: 44px;
  }
}
</style>
